import loading from '../helpers/loading'
import collection from '../helpers/collection'

import actions from './actions'

export default {
  namespaced: true,
  state: {
    ...loading.state,
    ...collection.state,
    expertsList: []
  },
  mutations: {
    ...loading.mutations,
    ...collection.mutations,
    updateExpertsList: (state, { list }) => (state.expertsList = list)
  },
  getters: {
    ...loading.getters,
    ...collection.getters,
    experts: (state, getters) => state.expertsList.map(id => getters.collection[id])
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/experts/index.js